module.exports = __webpack_public_path__ + "media/promo/courses/images/ic-1-bc7f92b83445a72dfcadc09b44d3049a.png";